import { getConfig } from './config';
import { BASE_PATH } from './state';

const stockAlertsUrl = `${BASE_PATH}/ajax/stock-alerts`;

const STORAGE_KEY_PREFIX = 'torgirt-stock-alerts-';

function getStorageKey(): string {
  const storefront = getConfig('storefront', 'i') as string;
  return STORAGE_KEY_PREFIX + storefront;
}

function getSubscribedArticles(): Set<string> {
  try {
    const raw = localStorage.getItem(getStorageKey());
    if (!raw) return new Set();
    return new Set(JSON.parse(raw));
  } catch {
    return new Set();
  }
}

function addSubscribedArticle(article: string): void {
  const set = getSubscribedArticles();
  set.add(article);
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify([...set]));
  } catch { /* quota exceeded — ignore */ }
}

export function isSubscribed(article: string): boolean {
  return getSubscribedArticles().has(article);
}

function markButtonSubscribed(btn: HTMLElement): void {
  btn.textContent = '\u2705 Вы подписаны';
  btn.classList.remove('btn-outline');
  btn.classList.add('btn-accent');
  btn.setAttribute('disabled', '');
  btn.removeAttribute('data-action');
}

async function doSubscribe(article: string, btn: HTMLElement, email?: string): Promise<void> {
  const csrfToken = getConfig('csrfToken', '') as string;
  const body: Record<string, string> = { article, csrf_token: csrfToken };
  if (email) {
    body.email = email;
  }

  btn.setAttribute('disabled', '');
  btn.textContent = '...';

  try {
    const res = await fetch(stockAlertsUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(body).toString(),
    });

    const data = await res.json();
    if (data.success || res.status === 200) {
      addSubscribedArticle(article);
      markButtonSubscribed(btn);
    } else {
      btn.textContent = data.error || 'Ошибка';
      btn.removeAttribute('disabled');
      setTimeout(() => { btn.textContent = 'Сообщить'; }, 2000);
    }
  } catch {
    btn.textContent = 'Ошибка сети';
    btn.removeAttribute('disabled');
    setTimeout(() => { btn.textContent = 'Сообщить'; }, 2000);
  }
}

function showEmailForm(btn: HTMLElement, article: string): void {
  const wrapper = btn.parentElement;
  if (!wrapper) return;

  const existing = wrapper.querySelector('.stock-alert-form');
  if (existing) return;

  const form = document.createElement('div');
  form.className = 'stock-alert-form';
  form.innerHTML = `
    <input type="email" placeholder="Email" class="stock-alert-email" autocomplete="email">
    <button type="button" class="btn btn-outline-neutral btn-sm stock-alert-submit">OK</button>
  `;

  wrapper.appendChild(form);

  const input = form.querySelector('.stock-alert-email') as HTMLInputElement;
  input.setAttribute('aria-label', 'Email для уведомления о поступлении');
  const submitBtn = form.querySelector('.stock-alert-submit') as HTMLButtonElement;

  input.focus();

  const submit = () => {
    const email = input.value.trim();
    if (!email || !email.includes('@')) {
      input.classList.add('is-invalid');
      input.focus();
      return;
    }
    input.classList.remove('is-invalid');
    form.remove();
    doSubscribe(article, btn, email);
  };

  submitBtn.addEventListener('click', submit);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') submit();
  });
}

export function handleStockAlertClick(el: HTMLElement): void {
  const article = el.dataset.article;
  if (!article) return;

  if (isSubscribed(article)) {
    markButtonSubscribed(el);
    return;
  }

  const isAuth = getConfig('isAuthenticated', false) as boolean;
  if (isAuth) {
    doSubscribe(article, el);
  } else {
    showEmailForm(el, article);
  }
}
